module.exports = __webpack_public_path__ + "static/media/event-services-img27.db3affe9.jpg";